import type { FaireProductEntity } from "../../entity_types/product";

export const p_h2ww6ungg7: FaireProductEntity = {
  token: "p_h2ww6ungg7",
  type: "product",
  name: "Virgin Mary Religious Necklace - Gold Plated",
  brandToken: "b_y2j497tv82",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/0d02a157c2d467a6560c287f2268bc4e240f0815c582baf4f117e4dc2abf260b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f3e4694683093907d5d9639ee2f56f996c2b012a56b6f4b3d7d8869863e87db6.jpeg",
  ],
  priceDollars: 3.88,
  description:
    "Virgin Mary Pendant\nColored crystal\nGold Plated Chain Charm\nPendant size 1.3CM * 2.5CM\nNecklace length 40CM+5CM",
  tags: [],
  msrpDollars: 7.76,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:47.033Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
